import React, { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import styles from './index.module.scss';
import { Description } from 'src/shared';
import { useLoadMp, useUpdateMpContractValue } from 'src/models/matchingProfiles/hooks';
import { debounce } from 'lodash';
import ContractValueFilter from 'src/shared/Tenders/ContractValueFilter';
import { MpContractValue } from 'src/models/matchingProfiles/types';
import { isNumber } from 'src/helpers';

interface Props {
  disabled?: boolean;
}
type FormState = MpContractValue;
const ContractValueMpFilter: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const { data: mp } = useLoadMp();
  const [form] = Form.useForm<FormState>();
  const [updateMpContractValue] = useUpdateMpContractValue();

  useEffect(() => {
    if (form.isFieldsTouched()) return;
    form.setFieldsValue({
      min: mp?.contractValueMin,
      max: mp?.contractValueMax,
      currency: mp?.contractValueCurrency,
      includeMissingValue: mp?.contractValueIncludeMissingValue
    });
  }, [form, mp]);

  const onUpdateValueMp = useMemo(
    () =>
      debounce(() => {
        const { min, max, currency, includeMissingValue } = form.getFieldsValue();

        updateMpContractValue({
          min: isNumber(min) ? Number(min) : undefined,
          max: isNumber(max) ? Number(max) : undefined,
          currency,
          includeMissingValue
        });
      }, 300),
    [form, updateMpContractValue]
  );

  return (
    <>
      <Description>
        <div className={styles.descriptionContainer}>{t('ExpiringContracts.estContractValueDesc')}</div>
      </Description>
      <Form form={form} onValuesChange={onUpdateValueMp}>
        <ContractValueFilter disabled={disabled} min={mp?.contractValueMin} max={mp?.contractValueMax} />
      </Form>
    </>
  );
};

export default ContractValueMpFilter;
